var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.124 0.655877C12.7332 0.448041 12.2647 0.448041 11.8739 0.655877L1.51245 6.16636L1.48908 6.15391L1.47056 6.18864L1.33895 6.25864C0.90439 6.48975 0.632812 6.94178 0.632812 7.43397V18.566C0.632812 19.0582 0.904388 19.5102 1.33895 19.7414L11.8739 25.3441C12.2647 25.552 12.7332 25.552 13.124 25.3441L23.6589 19.7414C24.0935 19.5102 24.3651 19.0582 24.3651 18.566V7.43397C24.3651 6.94178 24.0935 6.48975 23.6589 6.25864L13.124 0.655877ZM2.23025 8.36003V18.4061L12.1162 23.6637L12.1156 13.6348L7.97708 11.4265L7.97942 14.0761C7.9798 14.5172 7.6225 14.8751 7.18139 14.8755C6.74028 14.8759 6.38236 14.5186 6.38197 14.0775L6.37889 10.5737L2.23025 8.36003ZM22.7676 18.4061L13.7136 23.2212L13.7131 13.3973L22.7676 8.57025V18.4061ZM12.6916 12.1316L21.9846 7.17744L17.9689 5.04183L8.68264 9.99238L12.6916 12.1316ZM12.4989 2.13275L16.269 4.13778L6.98558 9.08683L3.21064 7.07253L12.4989 2.13275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.809de0ab.svg";
export { ForwardRef as ReactComponent };